export default __webpack_public_path__ + "assets/images/da6a48603c6ae1f00a7362b9d2b324c6.jpg";